import React from "react";
import { Pane, Text } from "shared";
import { useTranslation } from "react-i18next";
import { SPACING, Breakpoint } from "theme";
import { css } from "@emotion/css";
import { useHcp } from "api/hooks/useHCPs";

const HcpInfo: React.VFC = () => {
  const { t } = useTranslation();
  const { data: hcp } = useHcp();
  if (!hcp) return null;

  const details = [
    [t`form.email`, hcp.email],
    [t`form.phone`, hcp.phone_number],
    [t`form.address`, hcp.address],
    [t`settings.profile_information.time_zone`, hcp.iana_timezone],
    [t`form.slug`, hcp.slug],
    [t`form.admits_patients`, hcp.admits_patients ? t`buttons.yes` : t`buttons.no`],
  ].filter(([, value]) => value);

  return (
    <Pane dark className={styles.grid}>
      {details.map(([label, value]) => (
        <React.Fragment key={label}>
          <Text light nowrap>
            {label}
          </Text>
          <Text bold nowrap>
            {value}
          </Text>
        </React.Fragment>
      ))}
    </Pane>
  );
};

export default HcpInfo;

const styles = {
  grid: css`
    overflow: auto;
    display: grid;
    grid-auto-rows: 45px;
    align-items: center;
    grid-column-gap: ${SPACING}px;
    @media screen and (max-width: ${Breakpoint.sm - 1}px) {
      grid-template-columns: 1fr;
    }
    @media screen and (min-width: ${Breakpoint.sm}px) {
      grid-template-columns: auto 1fr;
    }
  `,
};
